<template>
  <div class="modal-body mdl-color--info mdl-color-text--info-contrast">
    <h4 class="mdl-subheader mdl-color-text--info-contrast">{{ header }}</h4>
    <span class="break-normal break-words whitespace-normal"><slot></slot></span>
  </div>
</template>

<script setup lang="ts">
defineProps({
  header: String,
})
</script>
